/* ==========================================================================
   FOOTBALL-THEME :: Add-to-cart moment.
   One causal pop the instant the cart count changes (any add/update path:
   product form, quick add, drawer quantity): the count bubble springs in
   and the cart icon rises with it, on the same frame as the update.

   This is the one place a little bounce is allowed - the event itself is a
   commit (the item landed), so a momentum-style overshoot reads as
   confirmation, not decoration. Disabled under prefers-reduced-motion.

   MutationObserver on #cart-icon-bubble, so it survives every section
   re-render and works for every add path. Depends on football-physics.js.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.fsPhysics || window.__fsCartMomentBoot) return;
  window.__fsCartMomentBoot = true;

  var reduceQuery =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function reduced() {
    return !!(reduceQuery && reduceQuery.matches);
  }

  var pops = new WeakMap();

  function pop(el, from, to, damping, response) {
    var spring = pops.get(el);
    if (!spring) {
      spring = window.fsPhysics.spring({
        from: from,
        to: from,
        damping: damping,
        response: response,
        epsilon: 0.004,
        onUpdate: function (value) {
          el.style.transform = 'scale(' + value.toFixed(4) + ')';
        }
      });
      pops.set(el, spring);
    } else {
      spring.jump(from);
    }
    spring.retarget(to, 0, damping, response, function () {
      el.style.transform = '';
    });
  }

  function countElement(root) {
    return root.querySelector('.fs-header__count, .cart-count-bubble');
  }

  function countText(root) {
    var el = countElement(root);
    if (!el) return null;
    var match = (el.textContent || '').replace(/\s+/g, ' ').match(/\d+/);
    return match ? match[0] : null;
  }

  var lastCount = null;

  function check() {
    var root = document.getElementById('cart-icon-bubble');
    if (!root) return;

    var count = countText(root);
    if (count === lastCount) return;

    var first = lastCount === null;
    lastCount = count;
    if (first || reduced()) return;

    var bubble = countElement(root);
    if (bubble) pop(bubble, 0.4, 1, 0.5, 0.3); /* springs in, slight overshoot */
    pop(root, 0.85, 1, 0.7, 0.35); /* the icon rises with it */
  }

  function start() {
    check();
    var root = document.getElementById('cart-icon-bubble');
    if (!root || !window.MutationObserver) return;
    new MutationObserver(check).observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
